import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh';
import { Tags } from '@babylonjs/core/Misc/tags';

import { Material3d, Model3d } from '../../../api/core-service/core-service.types';
import { getMaterialIndexFromMetadata } from './getMaterialIndexFromMetadata';
import { getMaterialUsageByName } from './getMaterialUsageByName';

export const setMaterialsTags = (
  root: AbstractMesh,
  articleInstanceId: string,
  model3d?: Model3d,
) => {
  const getMaterialUsage = getMaterialUsageFn(model3d?.materials);
  for (const mesh of root.getChildMeshes(false)) {
    if (!mesh.material) {
      continue;
    }
    const material = mesh.material;
    const index = getMaterialIndexFromMetadata(material);
    const usage =
      getMaterialUsage(index, material.name) || getMaterialUsageByName(material.name) || 'none';
    if (!Tags.HasTags(material)) {
      Tags.EnableFor(material);
      Tags.AddTagsTo(material, `${articleInstanceId} usage=${usage}`);
    }
  }
};

const getMaterialUsageFn = (materials3d?: Material3d[]) => (index: number, name: string) =>
  materials3d?.find((item) => item.index === index && item.name === name)?.usage;
